import { GameObjects } from "phaser";

import { convertStringToArray  } from '../utils';

export class TicketsList extends GameObjects.Container {
    constructor(scene, x, y, data) {
        super(scene, x, y);

        this.numbersArray = convertStringToArray(data.numbersArray.numbers);

        this.ticketNumber = data.ticketNumber+1;
        
        // Add this container to the scene
        scene.add.existing(this);


        const ticketNumberText = this.scene.add.text(-30, 0, `TICKET ${this.ticketNumber}`, {
            fontFamily: 'Oswald', 
            fontSize: '38px',
            color: '#fff',
        }).setOrigin(0, 0); // Set origin to top-left;
        ticketNumberText.setOrigin(0).setPadding({ left: 0,  top: 0 });
        ticketNumberText.setFontStyle('700')

        // Add the text object to this container
        this.add(ticketNumberText);



        // Call the method to create and display the text objects
        this.createGrid();



        // const ticketPriceText = this.scene.add.text(this.scale.width -64 , 12, `$${data.numbersArray.totalAmount}`, {
        //     fontFamily: 'Oswald', 
        //     fontSize: '20px',
        //     color: '#FFF',
        // }).setOrigin(1, 0); // Set origin to top-left;
        // ticketPriceText.setFontStyle('700')

        // this.add(ticketPriceText);


        // const ticketCostText = this.scene.add.text(ticketPriceText.x - ticketPriceText.width -10, 12, `COST:`, {
        //     fontFamily: 'Oswald', 
        //     fontSize: '20px',
        //     color: '#BEBEBE',
        // }).setOrigin(1, 0); // Set origin to top-left;
        // ticketCostText.setFontStyle('700')

        // this.add(ticketCostText);

        const bounds = this.getBounds()

        //console.log("bounds", bounds)


        const ticketPriceText = this.scene.add.text(bounds.width -50, 12, `$${data.numbersArray.price}`, {
            fontFamily: 'Oswald', 
            fontSize: '24px',
            color: '#FFF',
        }).setOrigin(1, 0); // Set origin to top-left;
        ticketPriceText.setFontStyle('700')

        this.add(ticketPriceText);

        const ticketCostText = this.scene.add.text(ticketPriceText.x - ticketPriceText.width - 16, 12, `COST:`, {
            fontFamily: 'Oswald', 
            fontSize: '24px',
            color: '#BEBEBE',
        }).setOrigin(1, 0); // Set origin to top-left;
        ticketCostText.setFontStyle('700')

        this.add(ticketCostText);



        //console.log("Number container bounds", this.getBounds())

    }

    // Method to create and display the grid of numbers as text objects
    createGrid() {
        const columns = 6;       // Number of columns
        const textSpacingX = (40 + 16)*2 ; // Horizontal space between text objects
        const textSpacingY = (40 + 16)*2; // Vertical space between text objects

        for (let i = 0; i < this.numbersArray.length; i++) {
            const number = this.numbersArray[i];

            // Calculate the x and y position for each text object
            const x = (i % columns) * textSpacingX;
            const y = Math.floor(i / columns) * textSpacingY + 116;

            // Create the text object for the current number

            
            const numberCircle = this.scene.add.sprite(x, y, 'pack' ,'Lotto Number - Unselected - Default.png');
            // Add the text object to this container
            this.add(numberCircle);

            const numberText = this.scene.add.text(x, y, number.toString(), {
                fontFamily: 'Montserrat',
                fontSize: '30px',
                color: '#fff',
            });
            numberText.setOrigin(0.5)
            numberText.setFontStyle('700')

            // Add the text object to this container
            this.add(numberText);
        }
    }


}